import React from 'react'

import { Span, ToolTip } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import './style.css'

interface IProps {
  tooltipText?: string | null
  tooltipFlow?: 'up' | 'down' | 'left' | 'right'
  size?: number
}

const InfoIcon = ({
  tooltipText = null,
  tooltipFlow = 'right',
  size = 16,
}: IProps) => (
  <Span className="info-icon">
    <ToolTip tethered flow={tooltipFlow} component={tooltipText}>
      <Icon
        name="info"
        className="info-icon-image"
        width={size}
        height={size}
      />
    </ToolTip>
  </Span>
)

export default InfoIcon
